export const HERO_CONSTANTS = {
  TAG: "AI Technology",
  DATE: "October 23, 2023",
  TITLE: "Revolutionize Your Photos with AI Image Enhancers",
  DESCRIPTION:
    "Discover how AI image enhancers can transform your photos by improving quality, clarity, and detail. Learn about the benefits and applications of using AI technology in photo editing.",
  HERO_IMAGE:
    "https://images.pexels.com/photos/1234567/pexels-photo-1234567.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
};

export const ARTICLE_SUMMARY = [
  "AI image enhancers are revolutionizing the way we edit photos by using advanced algorithms to improve quality, clarity, and detail. This guide explores the benefits and applications of AI technology in photo editing.",
  "From enhancing colors to removing noise, AI image enhancers offer a range of features that can transform your photos. We'll delve into the different tools available and how to use them effectively.",
  "Whether you're a professional photographer or a hobbyist, AI image enhancers provide powerful solutions for improving your photos. Let's explore the potential benefits and applications of AI technology in photo editing.",
];

export const ARTICLE_STEPS = [
  {
    title: "1. Understanding AI Image Enhancers",
    content:
      "AI image enhancers use advanced algorithms to analyze and improve photos. These tools can automatically adjust colors, remove noise, and enhance details, making your photos look more professional.",
  },
  {
    title: "2. Benefits of Using AI Image Enhancers",
    content:
      "AI image enhancers offer several benefits, including improved photo quality, ease of use, and time savings. These tools can quickly and accurately enhance your photos, allowing you to achieve professional results with minimal effort.",
  },
  {
    title: "3. Applications in Photo Editing",
    content:
      "AI image enhancers can be used in a variety of photo editing projects, from personal photos to professional photography. These tools are ideal for enhancing portraits, landscapes, and product photos, making them look more vibrant and detailed.",
  },
  {
    title: "4. Choosing the Right AI Image Enhancer",
    content:
      "When selecting an AI image enhancer, consider factors such as features, ease of use, and compatibility with your existing photo editing software. Look for tools that offer a range of enhancement options and provide high-quality results.",
  },
  {
    title: "5. Tips for Using AI Image Enhancers",
    content:
      "To get the best results from AI image enhancers, start with high-quality photos and use the tools' features to fine-tune the enhancements. Experiment with different settings to achieve the desired look, and don't be afraid to combine multiple tools for more advanced edits.",
  },
  {
    title: "6. Maintenance and Updates",
    content:
      "Keep your AI image enhancer software up to date to ensure you have access to the latest features and improvements. Regularly check for updates and take advantage of new tools and enhancements as they become available.",
  },
];

export const RELATED_ARTICLES = [
  {
    image:
      "https://images.pexels.com/photos/1234568/pexels-photo-1234568.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 20, 2023",
    title: "Top AI Tools for Photo Editing in 2023",
    description:
      "Explore the latest AI tools for photo editing in 2023. Learn how to use these tools to enhance your photos and achieve professional results.",
  },
  {
    image:
      "https://images.pexels.com/photos/1234569/pexels-photo-1234569.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 15, 2023",
    title: "How to Enhance Your Photos with AI Technology",
    description:
      "Discover practical tips for enhancing your photos with AI technology. Follow our step-by-step guide to achieve stunning results.",
  },
  {
    image:
      "https://images.pexels.com/photos/1234570/pexels-photo-1234570.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 12, 2023",
    title: "Choosing the Right AI Tools for Your Photo Editing Needs",
    description:
      "Learn about the different AI tools available for photo editing. Understand the benefits and applications of each tool to make informed decisions.",
  },
];

export const FOOTER_CONSTANTS = {
  CTA_TITLE: "Transform Your Photos with AI Image Enhancers",
  CTA_BACKGROUND:
    "https://images.pexels.com/photos/1234571/pexels-photo-1234571.jpeg",
  EMAIL_PLACEHOLDER: "Enter your email address",
  BUTTON_TEXT: "Learn More",
  COPYRIGHT: " 2024 AI Photo Editing Trends. All rights reserved",
};
